export const TOKEN_KEY = 'crypton_token';
